import { render, staticRenderFns } from "./FieldActionItem.vue?vue&type=template&id=2ea247ea&scoped=true"
import script from "./FieldActionItem.vue?vue&type=script&lang=js"
export * from "./FieldActionItem.vue?vue&type=script&lang=js"
import style0 from "./FieldActionItem.vue?vue&type=style&index=0&id=2ea247ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea247ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent})
